import React, {useEffect, useState} from 'react';
import {apiErrorRaised, useApiErrorDispatch} from "../../context/api_error/ApiErrorIndex";
import {Button, Table} from "reactstrap";
import {Auth} from "../../services/api/Auth";
import ManageUserItem from "./ManageUserItem";
import Paginator from "../Pagination/Paginator";
import {TableFilters} from "../TableFilters/TableFilters";
import {useTableFiltersState} from "../../context/table_filters/TableFiltersContext";

const ManageUsersList = () => {
  const dispatch = useApiErrorDispatch();
  const [deletedUserAccess, setDeletedUserAccess] = useState(false);
  const [isLoading, setLoading] = useState(false)
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({})
  const [offset, setOffset] = useState(0)
  const [limit, setLimit] = useState(10)
  const [isFiltersCollapsed, setFiltersCollapsed] = useState(true)
  const tableFilters = useTableFiltersState()

  // Function to load users
  const loadUsers = () => {
    setLoading(true);
    const params = {
      order: [{order_by: 'email', order_type: 'asc'}],
      limit: limit,
      offset: offset,
      filters: tableFilters
    }
    Auth.users(params).then((r) => {
      setLoading(false);
      if (r?.status < 400) {
        setUsers(r.data.users)
        setPagination(r?.data.pagination)
      } else {
        apiErrorRaised(dispatch, r?.response)
      }
    });
  };

  // Effect to reload users when dependencies change
  useEffect(() => {
    loadUsers();
  }, [dispatch, tableFilters, limit, offset, deletedUserAccess]);

  // Reset deleted flag after reloading
  useEffect(() => {
    if (deletedUserAccess) {
      setDeletedUserAccess(false);
    }
  }, [users, deletedUserAccess]);

  const handleClick = (e, offset, limit) => {
    e.preventDefault();
    setLimit(limit)
    setOffset(offset)
  }

  const toggleCollapsed = () => {
    setFiltersCollapsed(!isFiltersCollapsed)
  }

  return (
    <>
      <div className={'view_header'}>
        <div className={'title'}>
          <h1>Manage Users</h1>
        </div>
        <div className={'button_actions'}>
          <Button outline color="primary"
                  onClick={toggleCollapsed}>
            <span className="fa-filter fa me-1"/>
            Filters
          </Button>
        </div>
      </div>
      <TableFilters entity={'user'} isCollapsed={isFiltersCollapsed}/>
      <div className={'mt-3'}>
        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Email</th>
            <th scope="col">Full Name</th>
            <th scope="col">Role</th>
            <th scope="col">Status</th>
            <th scope="col">Last Login</th>
            <th scope="col">Last Access</th>
            <th colSpan="2" scope="col"></th>
          </tr>
          </thead>
          <tbody>
          {
            isLoading ?
              <tr>
                <td>
                  <span className="spinner-border spinner-border-lg me-1"/>
                </td>
              </tr>
              :
              users && users.map((user, i) => {
                return (
                  <ManageUserItem
                    key={i}
                    data={user}
                    setDeletedUserAccess={setDeletedUserAccess}
                    reloadUsers={loadUsers}
                  />
                );
              })
          }
          </tbody>
        </Table>
      </div>
      <Paginator
        pagination={pagination}
        handleClick={handleClick}
        offset={offset}
        limit={limit}
      />
    </>);
}

export default ManageUsersList;
